import React from "react";
import { Link } from "react-router-dom";
import linkedin from "../../assets/social-media-icons/linkedin.svg";
import youtube from "../../assets/social-media-icons/youtube.svg";
import facebook from "../../assets/social-media-icons/facebook.svg";
import instagram from "../../assets/social-media-icons/instagram.svg";
import { isExternalLink } from "../../helper/helper";
import styles from "./Footer.module.scss";

const SocialMediaIconWrapper = ({ footer }: { footer: any }) => {
  return (
    <div className={styles.socialMediaIconWrapper}>
      {isExternalLink(footer?.Linkedin) && (
        <Link
          to={footer?.Linkedin}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          title="LinkedIn"
          className={styles.link}
        >
          <img src={linkedin} alt="LinkedIn" />
        </Link>
      )}
      {isExternalLink(footer?.Facebook) && (
        <Link
          to={footer?.Facebook}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          title="Facebook"
          className={styles.link}
        >
          <img src={facebook} alt="Facebook" />
        </Link>
      )}
      {isExternalLink(footer?.Youtube) && (
        <Link
          to={footer?.Youtube}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Youtube"
          title="Youtube"
          className={styles.link}
        >
          <img src={youtube} alt="Youtube" />
        </Link>
      )}
      {isExternalLink(footer?.Instagram) && (
        <Link
          to={footer?.Instagram}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          title="Instagram"
          className={styles.link}
        >
          <img src={instagram} alt="Instagram" />
        </Link>
      )}
    </div>
  );
};

export default SocialMediaIconWrapper;
